import React from 'react'
import styled from '@emotion/styled'
import { SortDirectionOptions } from './types'

interface Props {
  onClick?: () => void
  sortDirection: SortDirectionOptions
  children: React.ReactNode
}

export const SorterTitle = ({ onClick, sortDirection, children }: Props) => {
  return (
    <Root onClick={onClick}>
      <div>
        <span>{children}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <TableSorter
          type='asc'
          isActive={sortDirection === SortDirectionOptions.ascend}
        />
        <TableSorter
          type='desc'
          isActive={sortDirection === SortDirectionOptions.descend}
        />
      </div>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

const TableSorter = styled.div(
  ({ type, isActive }: { type: string; isActive: boolean }) => `
  position: relative;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #4a4a68;
  opacity: ${isActive ? 1 : 0.5};
  transform: rotate(${type === 'asc' ? '180deg' : '0deg'});

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #f3f2f4;
    opacity: 1;
    top: -6px;
    left: -4px;
  }
`
)
